import { useEffect, useState } from 'react';
import { SortDirectionEnum, useFindByQuery } from '../../graphql';
import { Group } from '../domain';

export const useAllWorkspaceGroups = (workspaceId?: string) => {
  const [groups, setGroups] = useState<Group[]>([]);
  const [filter, setFilter] = useState<any | undefined>();

  useEffect(() => {
    if (!workspaceId) {
      return;
    }

    const filter: any = {
      workspace: { eq: workspaceId },
    };

    setFilter(filter);
  }, [workspaceId]);

  const { data, isLoading, invalidateQuery } = useFindByQuery({
    modelName: 'group',
    query: GET_ALL_GROUPS,
    variables: {
      filter,
      orderBy: {
        field: 'name',
        order: SortDirectionEnum.Asc,
      },
    },
    options: {
      enabled: !!filter,
    },
  });

  useEffect(() => {
    if (!data) {
      return;
    }
    setGroups(data.items);
  }, [data]);

  return {
    groups,
    isLoading,
    invalidateQuery,
  };
};

const GET_ALL_GROUPS = `
  query findGroups($filter: GroupFilter, $orderBy: OrderByInput) {
    findGroups(filter: $filter, orderBy: $orderBy) {
      items {
        id
        name
      }
    }
  }
`;
